const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-[background-color,color,box-shadow,transform] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 active:scale-[0.98]";

const tones = {
  blue: "bg-brand-blue text-white shadow-[var(--glow-blue)] hover:bg-brand-blueDark hover:translate-y-[var(--btn-lift)] focus-visible:ring-brand-blue",
  green: "bg-brand-greenDark text-white shadow-[var(--glow-green)] hover:bg-brand-greenDeep hover:translate-y-[var(--btn-lift)] focus-visible:ring-brand-greenDark",
  wa: "bg-brand-wa text-white shadow-[var(--glow-wa)] hover:bg-brand-waDark hover:translate-y-[var(--btn-lift)] focus-visible:ring-brand-wa",
  outline: "border border-brand-blue/30 bg-white text-brand-blue hover:bg-brand-tint focus-visible:ring-brand-blue",
  outlineGreen: "border border-brand-greenDark/40 bg-white text-brand-greenDark hover:bg-brand-greenTint focus-visible:ring-brand-greenDark",
  white: "bg-white text-brand-navy hover:bg-brand-tint focus-visible:ring-white",
  ghost: "text-brand-ink hover:bg-brand-tint focus-visible:ring-brand-blue",
};

const sizes = {
  sm: "h-10 px-4 text-sm",
  md: "h-12 px-6 text-base",
  lg: "h-14 px-7 text-base",
};

export const btn = (tone = "blue", size = "md") => `${base} ${tones[tone]} ${sizes[size]}`;

export const ACCENTS = [
  {
    icon: "bg-gradient-to-br from-brand-sky to-brand-blueBright text-white",
    soft: "bg-brand-skyTint",
    text: "text-brand-skyDeep",
    bar: "bg-brand-sky",
    glow: "hover:shadow-[0_28px_56px_-28px_rgba(14,165,233,0.6)]",
    chip: "hover:border-brand-sky hover:bg-brand-skyTint hover:text-brand-skyDeep",
  },
  {
    icon: "bg-gradient-to-br from-brand-blueBright to-brand-blue text-white",
    soft: "bg-brand-tint2",
    text: "text-brand-blue",
    bar: "bg-brand-blue",
    glow: "hover:shadow-[0_28px_56px_-28px_rgba(1,78,150,0.55)]",
    chip: "hover:border-brand-blue hover:bg-brand-tint hover:text-brand-blue",
  },
  {
    icon: "bg-gradient-to-br from-brand-lime to-brand-greenDark text-white",
    soft: "bg-brand-greenTint",
    text: "text-brand-greenDeep",
    bar: "bg-brand-green",
    glow: "hover:shadow-[0_28px_56px_-28px_rgba(83,147,35,0.55)]",
    chip: "hover:border-brand-green hover:bg-brand-greenTint hover:text-brand-greenDeep",
  },
  {
    icon: "bg-gradient-to-br from-brand-sun to-brand-coral text-white",
    soft: "bg-brand-warmTint",
    text: "text-brand-coralDeep",
    bar: "bg-brand-coral",
    glow: "hover:shadow-[0_28px_56px_-28px_rgba(249,115,22,0.5)]",
    chip: "hover:border-brand-coral hover:bg-brand-warmTint hover:text-brand-coralDeep",
  },
];

export const accent = (i) => ACCENTS[i % ACCENTS.length];
